export default __webpack_public_path__ + "static/media/740.5dbd8019.png";